import React from 'react';
import { useAppRoles } from '../hooks/useAppRoles';

/**
 * Dropdown of active application roles (built-in + custom).
 */
const RoleSelect = ({
  value,
  onChange,
  required = false,
  disabled = false,
  id,
  className,
  placeholder = '— Select role —',
}) => {
  const { data: roles = [], isLoading } = useAppRoles();

  return (
    <select
      id={id}
      className={className}
      value={value}
      onChange={onChange}
      required={required}
      disabled={disabled || isLoading}
    >
      <option value="">{isLoading ? 'Loading roles…' : placeholder}</option>
      {roles.map((role) => (
        <option key={role.slug} value={role.slug}>
          {role.label}
          {role.allows_login === false || role.slug === 'external' ? ' — no app login' : ''}
          {role.is_builtin ? '' : ` (${role.slug})`}
        </option>
      ))}
      {value && !roles.some((r) => r.slug === value) && (
        <option value={value}>{value} (inactive)</option>
      )}
    </select>
  );
};

export default RoleSelect;
